<template>
    <div class="Background">
        <h2 class="Title">LIVE 통계</h2>
        <LiveStatistics />
    </div>
</template>

<script>
import LiveStatistics from '@/components/statistics/livestatistics/LiveStatistics.vue';

export default {
    components: {
        LiveStatistics,
    },
    data() {
        return {

        };
    }
}
</script>

<style lang="scss" scoped>

</style>
